import { ACESFilmicToneMapping, WebGPURenderer } from 'three/webgpu';

/**
 * Create the renderer. WebGPURenderer uses the WebGPU API where available
 * and transparently falls back to WebGL2 elsewhere — one code path for both.
 */
export async function createRenderer(canvas: HTMLCanvasElement): Promise<WebGPURenderer> {
  const renderer = new WebGPURenderer({ canvas, antialias: true });
  renderer.toneMapping = ACESFilmicToneMapping;
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(window.innerWidth, window.innerHeight);
  await renderer.init();
  return renderer;
}
